export const FIRST_25_VARIABLES = { first: 25 }
export const FIRST_50_VARIABLES = { first: 50 }
